import gql from 'graphql-tag';
import { STATUS_REPLY_FRAGMENT } from '@/graphql/fragments/user-fragments';

export const UPDATE_USER_STATUS = gql`
${STATUS_REPLY_FRAGMENT}
mutation updateProfileStatus($body: Ugc!) {
  updateProfileStatus(body: $body) {
    body
    id
    insertedAt
    replies {
      ...StatusReplyFragment
    }
  }
}
`;

export const DELETE_USER_STATUS = gql`
mutation deleteProfileStatus($id: NexusId!) {
  deleteProfileStatus(id: $id) {
    id
  }
}
`;

export const REPLY_TO_USER_STATUS = gql`
${STATUS_REPLY_FRAGMENT}
  mutation createUserProfileStatusReply($body: Ugc!, $inReplyToId: NexusId, $userProfileStatusId: NexusId!) {
    createUserProfileStatusReply(body: $body, inReplyToId: $inReplyToId, userProfileStatusId: $userProfileStatusId ) {
      body
      id
      insertedAt
      isDeleted
      isPendingModeration
      inReplyTo {
        id
      }
      user {
        id
        username
        insertedAt
        roleId
        avatar {
          thumb
        }
      }
      replies: userProfileStatusReplies {
        ...StatusReplyFragment
      }
    }
  }
`;

export const DELETE_USER_STATUS_REPLY = gql`
mutation deleteUserProfileStatusReply($id: NexusId!) {
  deleteUserProfileStatusReply(id: $id) {
    id
    isDeleted
  }
}
`;
